import { Badge } from '@/components/ui/badge';
import type { JourneyDefinition } from '../types';

export function JourneyStatusBadge({ journey }: { journey: JourneyDefinition }) {
  if (journey.isActive) return <Badge variant="success">Active</Badge>;
  if (journey.killedAt) return <Badge variant="destructive">Killed</Badge>;
  return <Badge variant="muted">Inactive</Badge>;
}
